import React from 'react';

/**
 * ADS text input — optional search icon wrapper.
 */
const AdsInput = ({
  value,
  onChange,
  type = 'text',
  placeholder,
  className = '',
  compact = false,
  disabled = false,
  id,
  name,
  'aria-label': ariaLabel,
  ...props
}) => {
  const classes = ['ads-input', compact ? 'ads-input--compact' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <input
      id={id}
      name={name}
      type={type}
      className={classes}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      aria-label={ariaLabel}
      {...props}
    />
  );
};

export const AdsSearchInput = ({
  value,
  onChange,
  placeholder,
  icon: Icon,
  className = '',
  inputClassName = '',
  compact = true,
  ...props
}) => {
  return (
    <div className={`ads-search ${className}`.trim()}>
      {Icon ? <Icon size={16} className="ads-search__icon" aria-hidden /> : null}
      <AdsInput
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        compact={compact}
        className={inputClassName}
        {...props}
      />
    </div>
  );
};

export default AdsInput;
